



















// @ts-ignore
import v8n from 'v8n';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { authModule, snackModule } from '@/store';
import { ApiError } from '@/api';

@Component
export default class extends Vue {
  email: string = '';
  password: string = '';

  loading: boolean = false;
  valid: boolean = false;
  error: string = '';
  success: string = '';

  requiredString = [
    (v: string) =>
      v8n()
        .string()
        .not.empty()
        .test(v) || 'This field is required',
  ];

  clear() {
    this.error = '';
    // @ts-ignore
    this.$refs.loginForm.reset();
  }

  async login() {
    this.loading = true;
    try {
      await authModule.login({ email: this.email, password: this.password });
      authModule.closeLoginDialog(true);
      snackModule.showSnackbar('Login Successful');
      this.error = '';
      this.success = '';
    } catch (e) {
      this.error = e.response ? e.response.errors[0].detail : 'Unknown error';
    } finally {
      this.loading = false;
    }
  }

  forgotPassword() {
    this.$router.push({ name: 'forgot-password' });
    authModule.closeLoginDialog(false);
  }
}
